import { IError } from './types'

export const UserExistsException: IError = {
  code: 'UserExistsException',
  message: 'Selected user already exists in Vacation Tracker',
}

export const EmailAlreadyExists: IError = {
  code: 'EmailAlreadyExists',
  message: 'User with this email already exists',
}

export const UserNotFound: IError = {
  code: 'UserNotFound',
  message: 'User not found',
}

export const UserNotActive: IError = {
  code: 'UserNotActive',
  message: 'User no longer active',
}

export const EmailNotValid: IError = {
  code: 'EmailNotValid',
  message: 'Email not valid',
}

export const EmailPlatformUserInactive: IError = {
  code: 'EmailPlatformUserInactive',
  message: 'It seems that your status is set to inactive. Please, contact administrator to activate your status.',
}

export const AccessForbidden: IError = {
  code: 'AccessForbidden',
  message: 'Insufficient privilege - You shall not pass!',
}

export const UserEndDateNotEnabled: IError = {
  code: 'UserEndDateNotEnabled',
  message: 'User end date not enabled',
}

export const AdminsLimitReached: IError = {
  code: 'AdminsLimitReached',
  message: 'Admins limit reached',
}

export const AdministratorIsNotTheOnlyApprover: IError = {
  code: 'AdministratorIsNotTheOnlyApprover',
  message: 'Administrator must be the only approver',
}

export const UserIdNotFound: IError = {
  code: 'UserIdNotFound',
  message: 'User id not found',
}
